<script setup lang="ts">

const isProduction = process.env.NODE_ENV === 'production'

</script>

<template>
	<NuxtLayout>
		<div class="light">
			<NuxtPage />
			<Cookie v-if="isProduction"  />
		</div>
	</NuxtLayout>
</template>